// let localhost = 'kkomi-web.dev.pos.awh.co.id'; // buat web self order
// let localhost = 'kkomi-client.dev.pos.awh.co.id'; // buat client
// let localhost = 'ayi-client.dev.pos.awh.co.id'; // buat client
// let localhost = 'kkomi.dev.pos.awh.co.id'; // buat kasir pos
// let localhost = 'dusbam-voucher.dev.pos.awh.co.id'; // buat voucher generator
// let localhost = 'jsl.dev.pos.awh.co.id'; // buat voucher generator
// let localhost = 'bnb-laundry-client.dev.pos.awh.co.id'; // buat voucher generator
// let localhost = 'bnb-laundry-customer.dev.pos.awh.co.id'; // buat voucher generator
// let localhost = 'ptkpl-photobooth-client.dev.pos.awh.co.id'; // buat photobooth client
let localhost = 'bsd-its-kasir.dev.pos.awh.co.id'; // buat pos-its kasir
// let localhost = 'bsd-its-client.dev.pos.awh.co.id'; // buat pos-its client-area

let baseurl_api = 'https://jsl.dev.api.zeus.awh.co.id/';

// Deteksi tipe aplikasi berdasarkan URL`
// URL dengan '-client' (e.g., kkomi-client.dev.pos.awh.co.id) -> client-area
// URL dengan '-web' (e.g., kkomi-web.dev.pos.awh.co.id) -> web (self-order)
// URL dengan '-voucher' (e.g., kkomi-voucher.dev.pos.awh.co.id) -> voucher-generator
// URL tanpa suffix (e.g., kkomi.dev.pos.awh.co.id) -> pos-kasir
let appType: string = 'voucher-generator'; // default untuk local dev

let envTenant = 'jsl';
let envSuffix = '.dev';

// Untuk development local, gunakan localhost untuk simulasi
if (localhost) {
    const tenant = localhost.split('.dev.pos.awh.co.id')[0];
    envTenant = tenant.replace('-its-client', '').replace('-its-kasir', '').replace('-its', '').replace('-photobooth-client', '').replace('-photobooth-kasir', '').replace('-client', '').replace('-kasir', '').replace('-laundry-kasir', '').replace('-laundry-customer', '').replace('-laundry', '').replace('-photobooth', '').replace('-web', '').replace('-voucher', '');
    baseurl_api = `https://${envTenant}.dev.api.zeus.awh.co.id/`;
    if (tenant.endsWith('-its-client')) {
        appType = 'pos-its-client-area';
    } else if (tenant.endsWith('-its-kasir') || tenant.endsWith('-its')) {
        appType = 'pos-its-kasir';
    } else if (tenant.endsWith('-photobooth-client')) {
        appType = 'pos-photobooth-client-area';
    } else if (tenant.endsWith('-photobooth-kasir')) {
        appType = 'pos-photobooth-kasir';
    } else if (tenant.endsWith('-laundry-client')) {
        appType = 'pos-laundry-client-area';
    } else if (tenant.endsWith('-laundry-kasir')) {
        appType = 'pos-laundry-kasir';
    } else if (tenant.endsWith('-laundry-customer')) {
        appType = 'pos-laundry-customer';
    } else if (tenant.endsWith('-client')) {
        appType = 'client-area';
    } else if (tenant.endsWith('-voucher')) {
        appType = 'voucher-generator';
    } else if (tenant.endsWith('-web')) {
        appType = 'web';
    } else {
        appType = 'pos-kasir';
    }
}

// Override dengan hostname aktual jika bukan localhost
const currentHost = window.location.hostname;
if (currentHost.includes('.dev.pos.awh.co.id')) {
    const tenant = currentHost.split('.dev.pos.awh.co.id')[0];
    envTenant = tenant.replace('-its-client', '').replace('-its-kasir', '').replace('-its', '').replace('-photobooth-client', '').replace('-photobooth-kasir', '').replace('-client', '').replace('-kasir', '').replace('-laundry-kasir', '').replace('-laundry-customer', '').replace('-laundry', '').replace('-photobooth', '').replace('-web', '').replace('-voucher', '');
    baseurl_api = `https://${envTenant}.dev.api.zeus.awh.co.id/`;
    if (tenant.endsWith('-its-client')) {
        appType = 'pos-its-client-area';
    } else if (tenant.endsWith('-its-kasir') || tenant.endsWith('-its')) {
        appType = 'pos-its-kasir';
    } else if (tenant.endsWith('-photobooth-client')) {
        appType = 'pos-photobooth-client-area';
    } else if (tenant.endsWith('-photobooth-kasir')) {
        appType = 'pos-photobooth-kasir';
    } else if (tenant.endsWith('-laundry-client')) {
        appType = 'pos-laundry-client-area';
    } else if (tenant.endsWith('-laundry-kasir')) {
        appType = 'pos-laundry-kasir';
    } else if (tenant.endsWith('-laundry-customer')) {
        appType = 'pos-laundry-customer';
    } else if (tenant.endsWith('-client')) {
        appType = 'client-area';
    } else if (tenant.endsWith('-voucher')) {
        appType = 'voucher-generator';
    } else if (tenant.endsWith('-web')) {
        appType = 'web';
    } else {
        appType = 'pos-kasir';
    }
}

export const environment = {
    production: false,
    tenant: envTenant,
    envSuffix: envSuffix,
    appType: appType,
    https: '',
    baseurl_api: baseurl_api,
    baseurlStorage: 'https://ezgate.co.id/api_dev/',
    pathImg: '',
    path: '',
    auth: 'api/v1/login',
    register: 'register',
    token: '',
    refresh_token: 'auth/refresh',
    img_default:
        'https://zeus.awh.co.id/awh_pos/images/k4m3dNY7iv416BvZCtKgMsagFVlI6kHTVIpcq8TiA-AhZlmGJYgTV4PBHHTiGDk9JLzi9Lh6kfGcirloU39_xfJcfF7FsDol4NmfI-IjzLUyerd7uXyZkaFuaEYGbITi',
    payment_api: {
        baseUrl: 'https://payment.adhivasindo.co.id/',
        clientSecret: 'Z-jJ6vTEdbTeYEzFvOmot0Kam9Bi-KwljdNb-FU7Jr0' // PHOTOBOOTH_PAY_DEV
    },
    mqtt: {
        username: 'dhivapos',
        password: 'FurlaRasaMelon2024',
    },
};
